import { createRoot } from 'react-dom/client';
import { StrictMode } from 'react';
import App from './App.tsx';
import './index.css';
import { AppProviders } from './providers/AppProviders';
import { initSentry } from './lib/sentry';

// Sentry 초기화 (앱 렌더링 전에 실행)
initSentry();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AppProviders>
      <App />
    </AppProviders>
  </StrictMode>
);
